import * as React from 'react';
import { spinnerSize, Title } from '@patternfly/react-core';
import { Spinner } from '@patternfly/react-core';

interface ItemLoaderProps {
    showTitle?: boolean;
    title?: string;
    size?: spinnerSize;
}

const ItemLoader: React.FC<ItemLoaderProps> = ({ showTitle, title, size }) => {

    if (showTitle === undefined) {
        showTitle = true;
    }

    if (title === undefined) {
        title = "Loading";
    }

    if (size === undefined) {
        size = spinnerSize.xl;
    }

    return (
        <>
            {showTitle && <Title headingLevel="h3">{title}</Title>}
            <Spinner isSVG size={size} />
        </>
    )

};

export default ItemLoader;